var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":"租户保"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }